import React from 'react';
import { DateTimeFormater } from '../../../../services/Helper';

const ProductCancelNote = ({ product, assessment }) => (
  <div className="card note-card" style={{ background: "antiquewhite" }}>
    <div className="card-body">
      <p className="m-0 p-0 note-title">Product Cancelled</p>
      <p className="m-0 p-0 note-date">
        {assessment?.reviewAt ? DateTimeFormater(assessment?.reviewAt) : ""}
      </p>
      <p className="m-0 p-0 note-product">{product.productName}</p>
      <p className="m-0 p-0 note-body">{product.reason}</p>
    </div>
  </div>
);

export default ProductCancelNote;